/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import styled, { css } from 'styled-components';
import { GridContainer } from 'app/shared/ui';
import { Box } from '@rebass/grid';

import { media } from 'app/shared/styles_js/variables';

export const GridContainerSt = styled(GridContainer)`
  @media screen and (max-width: 719px) {
    grid-template-columns: repeat(12, 1fr);
    column-gap: 16px;
  }

  ${media.md(css`
    justify-items: center;
    align-items: center;
  `)}
`;

export const GridBoxSt = styled(Box)`
  grid-row: 1;
  grid-column: 1 / span 7;

  ${media.md(css`
    grid-row: 1;
  `)}
`;
